import styled from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/toyotaTheme";

// STYLES

// COMPONENTS
export const Wrapper = styled.article`
    display: flex;
    justify-content: flex-end;
    width: 100%;
    max-width: 100%;
    padding-inline: var(--spacing-2);
    padding-block-end: var(--spacing-7);

    @media screen and (min-width: ${breakpoints.md}) {
        padding-inline: var(--spacing-3);
        padding-block-end: var(--spacing-3);
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        padding-block-end: var(--spacing-10);
    }

    @media screen and (min-width: ${breakpoints.xxl}) {
        width: auto;
        padding-inline: var(--spacing-7);
    }

    @media screen and (min-width: ${breakpoints.max}) {
        padding-inline-start: 0;
    }

    @supports not (padding-inline: 0) {
        padding-bottom: var(--spacing-10);
        padding-left: 0;
        padding-right: var(--spacing-7);
    }
`;

export const Content = styled.div`
    width: 100%;
    max-width: 100%;

    @media screen and (min-width: ${breakpoints.xl}) {
        width: 764px;
    }

    @media screen and (min-width: ${breakpoints.xxl}) {
        width: 870px;
    }

    @media screen and (min-width: ${breakpoints.xxxl}) {
        width: 924px;
    }
`;
